import React from 'react';
import Button from '@omilia/button';

import { SButtonGroup, SFooterButton } from './styled';

type Props = {
  primary: {
    color?: React.ComponentProps<typeof Button>['color'];
    text: string;
    type: 'submit' | 'button';
    onClick?: () => void;
    loading?: boolean;
    disabled?: boolean;
  };
  secondary?: {
    text: string;
    onClick: () => void;
  };
};

const ModalButtons = ({
  primary: {
    text: primaryText,
    type = 'submit',
    color = 'primary',
    onClick: onPrimaryClick,
    loading = false,
    disabled = false,
  },
  secondary,
}: Props) => (
  <SButtonGroup>
    <>
      {secondary && (
        <SFooterButton
          color="secondary"
          type="button"
          variant="text"
          onClick={secondary.onClick}
        >
          {secondary.text}
        </SFooterButton>
      )}
    </>
    <SFooterButton
      color={color}
      disabled={disabled}
      loading={loading}
      type={type}
      variant="contained"
      onClick={onPrimaryClick}
    >
      {primaryText}
    </SFooterButton>
  </SButtonGroup>
);

export default ModalButtons;
